import React, { useContext } from 'react';
import { t, defineMessages } from '@sm/intl';
import { getHelpLink, StaticContext } from '@sm/webassets';
import { TopBarSlim } from '../TopBarSlim';

const COPY = defineMessages({
  MESSAGE: {
    id: 'ApiPricingChangesTopBarSlim.message',
    defaultMessage:
      'Upgrade now to keep access to your SurveyMonkey integrations.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'ApiPricingChangesTopBarSlim.ctaText',
    defaultMessage: 'Learn more',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
  BOLD_PREFIX: {
    id: 'ApiPricingChangesTopBarSlim.prefix',
    defaultMessage: 'Important:',
    description: '[Type: Header][Vis.: low] - Top bar slim prefix',
  },
});

export const ApiPricingChangesTopBarSlim: React.FC = () => {
  const {
    user: { languageCode },
  } = useContext(StaticContext);
  const url = getHelpLink(languageCode, {
    helpName: 'SurveyMonkey-Partner-Integrations-Changes',
    params: {
      ut_source: 'topbar',
      ut_source2: 'api_pricing_changes',
    },
  });

  return (
    <TopBarSlim
      message={t(COPY.MESSAGE)}
      ctaText={t(COPY.CTA_TEXT)}
      ctaLink={url}
      prefix={t(COPY.BOLD_PREFIX)}
    />
  );
};

export default ApiPricingChangesTopBarSlim;
